export default {
  data () {
    return {
      columns: [
        {
          label: 'Дата создания',
          field: 'createdAt',
          name: 'createdAt',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Файл',
          field: 'name',
          name: 'name',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Действия',
          name: 'edit',
          field: 'id',
          sortable: false,
          align: 'right'
        }
      ],
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/DocumentsList/mixins/columns.js